import { render, staticRenderFns } from "./CcAnchorSetup.vue?vue&type=template&id=24adb81c&scoped=true"
import script from "./CcAnchorSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./CcAnchorSetup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcAnchorSetup.vue?vue&type=style&index=0&id=24adb81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24adb81c",
  null
  
)

export default component.exports